<template>
  <v-container class="py-8">
    <loading-spinner v-if="loading"> </loading-spinner>
    <template v-else>
      <survey-intro v-if="step == 0"></survey-intro>
      <profile-form v-else-if="!is_active"></profile-form>
      <survey-container v-else></survey-container>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import SurveyContainer from "@/components/survey/SurveyContainer";
import ProfileForm from "@/components/profile/ProfileForm";
import SurveyIntro from "@/components/survey/SurveyIntro";
export default {
  name: "SurveyDetail",
  components: {
    "survey-container": SurveyContainer,
    "profile-form": ProfileForm,
    "survey-intro": SurveyIntro
  },
  data: () => ({ loading: false }),
  computed: mapGetters({
    survey: "survey/survey",
    is_active: "profile/is_active",
    step: "survey/step"
  }),
  created() {
    this.loading = true;
    this.$store.dispatch("survey/setIsPreview", false).then(() =>
      this.$store
        .dispatch("profile/getProfile", { id: this.$route.params.id })
        .then(() =>
          this.$store.dispatch("survey/getSurvey", this.$route.params.id)
        )
        .finally(() => {
          this.loading = false;
        })
    );
  }
};
</script>
